import React, { useEffect } from "react";
// Store Utils
import { useDispatch } from "react-redux";
import {
  managerTypeAction,
  observationsStatusAction,
} from "store/filters/reducer.actions";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { sentenceCase } from "change-case";
import { filtersInitialState } from "store/filters/initialState";
import { updateColumnsVisibilityOfManagersByStatus } from "store/directoriesOrders/reducer.actions";

interface TabsProps {}

export const Tabs: React.FC<TabsProps> = ({}) => {
  const { managerFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );
  const dispatch = useDispatch();
  const TabsData = [
    {
      title: "INTERNAL",
      value: "internal",
    },
    {
      title: "EXTERNAL REVIEWERS",
      value: "external",
    },
    {
      title: "EXTERNAL DATA-END VIEWERS",
      value: "external_data_end_viewer",
    },
  ];
  useEffect(() => {
    dispatch(updateColumnsVisibilityOfManagersByStatus(managerFilter.type));
  }, [managerFilter.type]);

  //handlers
  const handleLink = (linkName: string) => {
    dispatch(managerTypeAction(linkName));
  };
  
  return (
    <>
      {TabsData.map((item: any, index: number) => {
        return (
          <div
            key={index}
            className={`group flex cursor-pointer justify-center items-center flex-grow-0 flex-shrink-0 px-4 py-3 ${
              managerFilter.type === item.value
                ? "border-b-2 border-primaryMid "
                : "border-lineMid border-b-2  hover:border-lineDarkExtra"
            }`}
            onClick={() => handleLink(item.value)}
          >
            <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 relative px-1.5 pt-1.5 pb-2 ">
              <p
                className={`flex-grow-0 flex-shrink-0 text-sm font-semibold text-center uppercase text-secondary group-hover:dark:text-textMain ${
                  managerFilter.type === item.value
                    ? " dark:text-textMain "
                    : "dark:text-caption "
                }`}
              >
                {item.title}
              </p>
            </div>
          </div>
        );
      })}
    </>
  );
};
